'use client';

import { Icon } from '@plura/client/components';
import { cn } from '@plura/shared/utils';
import { useCallback, useEffect, useRef, useState } from 'react';

const ReadingEnhancements = () => {
  const progressRef = useRef<HTMLDivElement>(null);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const updateState = useCallback(() => {
    const hero = document.getElementById('page-hero');
    const scrollY = window.scrollY;

    if (hero) {
      const heroBottom = hero.getBoundingClientRect().bottom + scrollY;
      setShowScrollTop(scrollY > heroBottom);
    }

    if (progressRef.current) {
      const footer = document.querySelector('footer');
      const footerTop = footer
        ? footer.getBoundingClientRect().top + scrollY
        : document.documentElement.scrollHeight;
      const endPoint = footerTop - window.innerHeight;

      const pct = endPoint > 0
        ? Math.min((scrollY / endPoint) * 100, 100)
        : 0;
      progressRef.current.style.width = `${pct}%`;
    }
  }, []);

  useEffect(() => {
    updateState();
    window.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState, { passive: true });
    return () => {
      window.removeEventListener('scroll', updateState);
      window.removeEventListener('resize', updateState);
    };
  }, [updateState]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <div className="pointer-events-none fixed top-0 left-0 z-[100] h-0.5 w-full bg-transparent">
        <div
          ref={progressRef}
          className="h-full w-0 rounded-br-sm rounded-tr-sm bg-primary shadow-[0_0_6px_rgba(55,20,16,0.4)]"
        />
      </div>

      <button
        type="button"
        className={cn(
          'fixed right-8 bottom-8 z-[999] flex size-10 cursor-pointer items-center justify-center rounded-[10px] border border-[#e5e5e5] bg-white text-dark shadow-[0_2px_8px_rgba(0,0,0,0.08)] transition-[opacity,transform,background-color,border-color] duration-[250ms] ease-in-out max-md:right-5 max-md:bottom-5 max-md:size-9',
          '[&_svg_path]:fill-current',
          'hover:border-dark hover:bg-dark hover:text-white',
          showScrollTop ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0',
        )}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <Icon name="arrow" className="-rotate-90 !size-5 fill-current" aria-hidden />
      </button>
    </>
  );
};

export default ReadingEnhancements;
